module.exports = __webpack_public_path__ + "img/logomark-usage-example1.80c1f14a.png";